import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class ChatProvider {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getMessages(payload) {
    return this._http.get(
      this.baseUrl + `/public/chat/session/${payload.sessionId}/message/`,
      {
        params: payload.params,
      }
    );
  }

  sendMessage(payload) {
    return this._http.post(
      this.baseUrl + `/public/chat/session/${payload.sessionId}/message/`,
      payload.body
    );
  }
  getSession(payload) {
    return this._http.get(
      this.baseUrl + `/public/chat/session/${payload.sessionId}/`
    );
  }

}
